module.exports = __webpack_public_path__ + "img/personal_collect_active.c58c524e.png";